import { NgModule } from "@angular/core";
import { AssetTransactionListDetailComponent } from "./components/transaction-list/transaction-list-detail/asset-transaction-list-detail/asset-transaction-list-detail.component";
import { AssetTransactionListFooterComponent } from "./components/transaction-list/transaction-list-footer/asset-transaction-list-footer.component";
import { AssetTransactionListHeaderComponent } from "./components/transaction-list/transaction-list-header/asset-transaction-list-header/asset-transaction-list-header.component";
import { FiatTransactionListDetailComponent } from "./components/transaction-list/transaction-list-detail/fiat-transaction-list-detail/fiat-transaction-list-detail.component";
import { FiatTransactionListHeaderComponent } from "./components/transaction-list/transaction-list-header/fiat-transaction-list-header/fiat-transaction-list-header.component";
import { FiatTransactionListFooterComponent } from "./components/transaction-list/transaction-list-footer/fiat-transaction-list-footer.component";
import { TransactionListTagComponent } from "./components/transaction-list/transaction-list-header/transaction-list-tag/transaction-list-tag.component";
import { TransactionListDetailTemplateComponent } from "./components/transaction-list/transaction-list-detail/transaction-list-detail-template/transaction-list-detail-template.component";
import { TransactionListHeaderTemplateComponent } from "./components/transaction-list/transaction-list-header/transaction-list-header-template/transaction-list-header-template.component";
import { TransactionWrapperModalComponent } from "./modals/transaction-wrapper-modal/transaction-wrapper-modal.component";
import { ActionsBarComponent } from "../main/components/actions-bar/actions-bar.component";
import { CoreModule } from "../core/core.module";
import { FilterModule } from "../main/components/filters/filter.module";
import { ActionButtonModule } from "../action-buttons/action-button.module";
import { TradableTransactionListItemComponent } from "./components/transaction-list/transaction-list-item/tradable-transaction-list-item/tradable-transaction-list-item.component";
import { FiatTransactionListItemComponent } from "./components/transaction-list/transaction-list-item/fiat-transaction-list-item/fiat-transaction-list-item.component";
import { IndexTransactionListHeaderComponent } from "./components/transaction-list/transaction-list-header/index-transaction-list-header/index-transaction-list-header.component";
import { IndexTransactionListDetailComponent } from "./components/transaction-list/transaction-list-detail/index-transaction-list-detail/index-transaction-list-detail.component";
import { IndexWalletTransactionComponent } from "./components/wallet-transaction/index-wallet-transaction/index-wallet-transaction.component";
import { TradableWalletTransactionComponent } from "./components/wallet-transaction/tradable-wallet-transaction/tradable-wallet-transaction.component";
import { ShareButtonComponent } from "@modules/social-trading/components/share-button/share-button.component";
import { TransactionPendingRibbonComponent } from "./components/transaction-pending-ribbon/transaction-pending-ribbon.component";
import { BpPillInfoModule } from "@modules/shared/bp-pill-info/bp-pill-info.module";
import { BpGeneralBannerModule } from "@modules/shared/bp-general-banner/bp-general-banner.module";
import { CashPlusModule } from "@modules/cashplus/cashplus.module";
import { FiatWalletTransactionComponent } from "@modules/transaction/components/wallet-transaction/fiat-wallet-transaction/fiat-wallet-transaction.component";
import { TaxDeclarationPromptComponent } from "./components/transaction-list/transaction-list-detail/transaction-list-detail-template/tax-declaration-prompt/tax-declaration-prompt.component";
import { RouterModule, Routes } from "@angular/router";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { transactionRouteResolverFn } from "./transaction.route.resolver";
import { LegacyLabelComponent } from "@modules/real-stocks/digi-sunset/legacy-label/legacy-label.component";
import { SunsetDigiBannerComponent } from "@modules/real-stocks/digi-sunset/adp-banner/sunset-digi-banner/sunset-digi-banner.component";
import { RealSecuritiesBannerComponent } from "@modules/core/components/real-securities-banner/real-securities-banner.component";

const components = [
	TradableTransactionListItemComponent,
	AssetTransactionListHeaderComponent,
	IndexTransactionListHeaderComponent,
	IndexTransactionListDetailComponent,
	AssetTransactionListDetailComponent,
	AssetTransactionListFooterComponent,
	FiatTransactionListItemComponent,
	FiatTransactionListHeaderComponent,
	FiatTransactionListDetailComponent,
	FiatTransactionListFooterComponent,
	TransactionWrapperModalComponent,
	TransactionListHeaderTemplateComponent,
	TransactionListDetailTemplateComponent,
	TransactionListTagComponent,
	TradableWalletTransactionComponent,
	IndexWalletTransactionComponent,
	ActionsBarComponent,
	TransactionPendingRibbonComponent,
	FiatWalletTransactionComponent,
	TaxDeclarationPromptComponent
];

const routes: Routes = [
	{
		path: "open-transaction",
		component: ModalHolderComponent,
		resolve: {
			tx: transactionRouteResolverFn
		}
	}
];

@NgModule({
	imports: [
		CoreModule,
		FilterModule,
		ActionButtonModule,
		BpPillInfoModule,
		BpGeneralBannerModule,
		CashPlusModule,
		RouterModule.forChild(routes),
		LegacyLabelComponent,
		SunsetDigiBannerComponent,
		RealSecuritiesBannerComponent
	],
	declarations: [...components, ShareButtonComponent],
	exports: [...components]
})
export class TransactionModule {}
